export default {
    getVictimasRepresentante(usuario) {
      return new Promise((resolve, reject) => {
        let ruta = `/api/representante/${usuario.id}/persona`;
        return axios.get(ruta).then((response) => {
          resolve(response.data)
        }, response => {
          resolve(response.data)
        });
      })
    }
  }